export const LANG: string = 'lang';
